<script>
export default {
  props: {
    value: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
  },
  computed: {
    percentage() {
      return Math.round((this.value * 100) / this.max) + '%'
    },
  },
}
</script>

<template>
  <div class="custom-progress">
    <div class="progress-bg-bar">
      <div
        :style="{ width: percentage }"
        class="progress-bar"/>
    </div>
    <span>Progress</span>
    <span class="right-label">{{ percentage }}</span>
  </div>
</template>

<style scoped>
.custom-progress {
  max-width: 200px;
  position: relative;
}
.progress-bg-bar {
  background-color: #ced4da;
  border-radius: 15px;
}
.progress-bar {
  background-color: #29a377;
  border-radius: 15px;
  height: 12px;
}
.right-label {
  display: inline-block;
  float: right;
}
</style>
